import { create } from "zustand";
import { createMenuSlice } from "./MenuSlice";
import { createQuestionSlice } from "./QuestionSlice";

const useStore = create((set) => ({
  isVerified: false,

  ...createMenuSlice(set),
  ...createQuestionSlice(set),
}));

export default useStore;
export const useIsVerified = () => useStore((state) => state.isVerified);
